"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
require("./fontawesome");
// get our fontawesome library imports

const Icon = props => {
  return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, props);
};
exports.Icon = Icon;
Icon.propTypes = {
  /** Array of `style prefix` & `icon name`. Example: `icon: ['fas', 'search']`. */
  icon: _propTypes.default.arrayOf(String).isRequired,
  /** Specify React style object. */
  style: _propTypes.default.object,
  /** Specify the size.  */
  size: _propTypes.default.oneOf(['xs', 'sm', 'lg', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  /** Specify the number of degrees. */
  rotation: _propTypes.default.oneOf([90, 180, 270]),
  /** Specify `HEX`, `rgba` OR color name like `blue` */
  color: _propTypes.default.string,
  /** Bind `onClick` function for additional behaviour. */
  onClick: _propTypes.default.func
};